<template>
    <div>
        <v-card>
            <v-card-title>Insert New AY Permits</v-card-title>
            <v-card-text>
                <div class="px-2">
                    <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                         <div class="w-full md:w-1/2 px-2">
                             <v-text-field v-model="newaypermit.year" prepend-icon="calendar_today" label="Year(2 digits - YY)"></v-text-field>
                         </div>
                        <div class="w-full md:w-1/2 px-2">
                            <v-select v-model="newaypermit.permityType" :items="dropdownPermitPrefixOptions" item-value="value" item-text="text" prepend-icon="category" label="Permit Prefix"></v-select>
                        </div>
                        <div class="w-full md:w-1/2 px-2">
                            <v-text-field v-model="newaypermit.startTag" prepend-icon="keyboard_arrow_left" label="Start Tag"></v-text-field>
                        </div>
                        <div class="w-full md:w-1/2 px-2">
                            <v-text-field v-model="newaypermit.endTag" prepend-icon="keyboard_arrow_right" label="End Tag"></v-text-field>
                        </div>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="clear" color="error">Clear</v-btn>
                <v-btn :loading="loadingSubmitButton" @click="save" color="success">Submit</v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                appURL: process.env.MIX_APP_URL,
                loadingSubmitButton: false,
                dropdownPermitPrefixOptions: [
                    { text: 'Annual Permits', value: 'A'},
                    { text: 'East Campus Housing', value: 'E'},
                    { text: 'Fall Permits', value: 'F'},
                    { text: 'Payroll Deduction', value: 'P'},
                    { text: 'Resident Permits', value: 'R'},
                    { text: 'West Campus Housing', value: 'W'},
                ],
                newaypermit: {
                    year: '',
                    permityType: '',
                    startTag: '',
                    endTag: ''
                },
            }
        },
        created() {

        },
        methods: {
            save: function() {
                //Update
                this.loadingSubmitButton = true;
                axios.post(this.appURL + '/api/newaypermits/', {
                    permit_year: this.newaypermit.year,
                    permit_type: this.newaypermit.permityType,
                    startTag: this.newaypermit.startTag,
                    endTag: this.newaypermit.endTag,
                }).then((response) => {
                    if(response.status === 200)
                    {

                    }
                    this.clear();
                    this.loadingSubmitButton = false;
                }).catch(error => {
                    console.log(error);
                    this.clear();
                    this.loadingSubmitButton = false;
                });
            },
            clear: function() {
                this.newaypermit.year = '';
                this.newaypermit.permityType = '';
                this.newaypermit.startTag = '';
                this.newaypermit.endTag = '';
            }
        }
    }
</script>
